module.exports = __webpack_public_path__ + "a35f4d1373ac7f0da5697751339b9a0b.jpg";